module.exports = __webpack_public_path__ + "static/media/USDT-BUSD.55a23c49.png";